module.exports = __webpack_public_path__ + "static/media/lingualRetainer.4b2f3b7f.svg";